import { PLATFORMS } from '@/domains/core/settings/constants';

export const socialNetworksLinks = {
  [PLATFORMS.FRANCE]: [
    {
      id: 'linkedin',
      href: 'https://www.linkedin.com/company/manomano/mycompany/',
      dataQa: 'contactLinkedinCta',
      name: 'Linkedin',
    },
    {
      id: 'facebook',
      href: 'https://www.facebook.com/manomanoFR/',
      dataQa: 'contactFacebookCta',
      name: 'Facebook',
    },
    {
      id: 'pinterest',
      href: 'https://www.pinterest.fr/manomano_FR/',
      dataQa: 'contactPinterestCta',
      name: 'Pinterest',
    },
    {
      id: 'instagram',
      href: 'https://www.instagram.com/manomano.fr/',
      dataQa: 'contactInstagramCta',
      name: 'Instagram',
    },
  ],
  [PLATFORMS.SPAIN]: [
    {
      id: 'linkedin',
      href: 'https://www.linkedin.com/company/manomano/mycompany/',
      dataQa: 'contactLinkedinCta',
      name: 'Linkedin',
    },
    {
      id: 'facebook',
      href: 'https://www.facebook.com/ManoMano.es',
      dataQa: 'contactFacebookCta',
      name: 'Facebook',
    },
    {
      id: 'instagram',
      href: 'https://www.instagram.com/manomano.es/',
      dataQa: 'contactInstagramCta',
      name: 'Instagram',
    },
    {
      id: 'youtube',
      href: 'https://www.youtube.com/channel/UCQ4Ry8e-4Y7CJUVx277hWJA',
      dataQa: 'contactYouTubeCta',
      name: 'Youtube',
    },
  ],
  [PLATFORMS.ITALY]: [
    {
      id: 'linkedin',
      href: 'https://www.linkedin.com/company/manomano/mycompany/',
      dataQa: 'contactLinkedinCta',
      name: 'Linkedin',
    },
    {
      id: 'facebook',
      href: 'https://www.facebook.com/manomanoitalia',
      dataQa: 'contactFacebookCta',
      name: 'Facebook',
    },
    {
      id: 'instagram',
      href: 'https://www.instagram.com/manomano.it',
      dataQa: 'contactInstagramCta',
      name: 'Instagram',
    },
    {
      id: 'youtube',
      href: 'https://www.youtube.com/channel/UCv21PK58Zz27gL90IGS-Sdg',
      dataQa: 'contactYouTubeCta',
      name: 'Youtube',
    },
  ],
  [PLATFORMS.GREAT_BRITAIN]: [
    {
      id: 'linkedin',
      href: 'https://www.linkedin.com/company/manomano/mycompany/',
      dataQa: 'contactLinkedinCta',
      name: 'Linkedin',
    },
    {
      id: 'facebook',
      href: 'https://www.facebook.com/manomanoUK/',
      dataQa: 'contactFacebookCta',
      name: 'Facebook',
    },
    {
      id: 'instagram',
      href: 'https://www.instagram.com/manomano.co.uk',
      dataQa: 'contactInstagramCta',
      name: 'Instagram',
    },
    {
      id: 'pinterest',
      href: 'https://uk.pinterest.com/ManoManoUK/',
      dataQa: 'contactPinterestCta',
      name: 'Pinterest',
    },
  ],
  [PLATFORMS.GERMANY]: [
    {
      id: 'linkedin',
      href: 'https://www.linkedin.com/company/manomano/mycompany/',
      dataQa: 'contactLinkedinCta',
      name: 'Linkedin',
    },
    {
      id: 'facebook',
      href: 'https://www.facebook.com/manomanode',
      dataQa: 'contactFacebookCta',
      name: 'Facebook',
    },
    {
      id: 'youtube',
      href: 'https://www.youtube.com/channel/UCip55scEHV8-DTjx5v7cWuQ',
      dataQa: 'contactYouTubeCta',
      name: 'Youtube',
    },
    {
      id: 'instagram',
      href: 'https://www.instagram.com/manomano.de/?hl=de',
      dataQa: 'contactInstagramCta',
      name: 'Instagram',
    },
  ],
};
